import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Language, LanguageResources } from './i18n.constants';

const { en, cn, tr } = LanguageResources;

export const defaultNS = 'translations';
export const resources = {
  [Language.EN]: {
    translations: en,
  },
  [Language.TR]: {
    translations: tr,
  },
  [Language.CN]: {
    translations: cn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: Language.EN,
    lng: 'en',
    ns: ['translations'],
    defaultNS,
    resources,
  });
